import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { keyBy, some } from 'lodash';

import CallLists from './call_lists';
import configureStore from './store/configure';
import { getLastSelectedCallListId, setLastSelectedCallListId } from './local_storage';

const getDefaultCallListId = (props) => {
  const { callLists, initialCallListId } = props;
  if (callLists.length === 0) return null;

  if (initialCallListId && some(callLists, list => list.id === initialCallListId)) {
    setLastSelectedCallListId(initialCallListId);
    return initialCallListId;
  }

  const defaultId = getLastSelectedCallListId();
  if (defaultId && some(callLists, list => list.id === defaultId)) {
    return defaultId;
  } else {
    return callLists[callLists.length - 1].id;
  }
};

export class CallListIndex extends React.Component {
  static propTypes = {
    availableDatabases: PropTypes.array.isRequired,
    callLists: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string
      })
    ).isRequired,
    contactPreviewProps: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    databaseMembers: PropTypes.array.isRequired,
    initialCallListId: PropTypes.number,
    paths: PropTypes.object.isRequired
  };

  store = configureStore({
    paths: this.props.paths,
    static: {
      availableDatabases: this.props.availableDatabases,
      currentUser: this.props.currentUser,
      databaseMembers: this.props.databaseMembers
    },
    search: {
      currentCallList: {},
      tags: [],
      tasks: []
    },
    query: {
      assigneeId: null,
      callListId: getDefaultCallListId(this.props),
      creatorId: null,
      endDate: null,
      includeUntagged: false,
      startDate: null,
      status: null,
      tagIds: [],
      type: 'call'
    },
    selectList: {
      selectedTaskIds: []
    },
    tasks: {
      startBulkDeleteTasks: false,
      startBulkRemoveTasks: false,
    },
    ui: {
      callLists: keyBy(this.props.callLists, cl => cl.id),
      contactPreviewProps: this.props.contactPreviewProps,
      previewOverlayRecordId: this.props.contactPreviewProps.contactId,
      previewOverlayRecordType: this.props.contactPreviewProps.contactType,
      previewOverlayTaskId: this.props.contactPreviewProps.taskId,
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <CallLists />
      </Provider>
    );
  }
}

export default CallListIndex;
